import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const LibyaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15370'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15370)'>
				<g filter='url(#filter0_d_2332_15370)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 9.33329H20V4.66663H0V9.33329Z'
						fill='#262626'
					/>
				</g>
				<g filter='url(#filter1_d_2332_15370)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14H20V9.33337H0V14Z'
						fill='#34B857'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#F41F34'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0008 8.39998C10.2946 8.39998 10.5677 8.31308 10.7947 8.16408C10.7684 8.16578 10.7419 8.16664 10.7151 8.16664C10.0576 8.16664 9.52465 7.64431 9.52465 6.99998C9.52465 6.35564 10.0576 5.83331 10.7151 5.83331C10.7419 5.83331 10.7684 5.83417 10.7947 5.83587C10.5677 5.68687 10.2946 5.59998 10.0008 5.59998C9.21186 5.59998 8.57227 6.22678 8.57227 6.99998C8.57227 7.77317 9.21186 8.39998 10.0008 8.39998ZM11.4294 6.99998C11.4294 7.25771 11.2162 7.46664 10.9532 7.46664C10.6902 7.46664 10.477 7.25771 10.477 6.99998C10.477 6.74224 10.6902 6.53331 10.9532 6.53331C11.2162 6.53331 11.4294 6.74224 11.4294 6.99998Z'
					fill='white'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_15370'
					x='0'
					y='4.66663'
					width='20'
					height='4.66663'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15370'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15370'
						result='shape'
					/>
				</filter>
				<filter
					id='filter1_d_2332_15370'
					x='0'
					y='9.33337'
					width='20'
					height='4.66663'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15370'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15370'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default LibyaFlagIcon;
